import {
  Button,
  IconButton,
  LinearProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@material-ui/core';
import React, { useRef, useState } from 'react';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import PublishRoundedIcon from '@material-ui/icons/PublishRounded';
import FileDownloadIcon from '@material-ui/icons/GetApp';
import { makeStyles } from '@material-ui/core/styles';
import { useFetchContext } from '../../../common/FetchContext';
import { usePostReportTemplateUpload } from '../../../common/services/fileServices';
import { toast } from 'react-toastify';
import moment from 'moment';
import { useReportFileTemplate } from '../../projectManagementQueries';


const useStyles = makeStyles({
  container: {
    padding: 24,
    display: 'flex',
    justifyContent: 'center',
  },
  table: {
    maxWidth: 800,
    minWidth: 500,
    border: '1px solid #ccc',
    borderRadius: 8,
  },
  header: {
    backgroundColor: '#f5f5f5',
    fontWeight: 'bold',
  },
  cell: {
    fontSize: 14,
    padding: '12px 16px',
  },
  row: {
    '&:hover': {
      backgroundColor: '#f0f8ff',
    },
  },
  iconButton: {
    color: '#1976d2',
    '&:hover': {
      color: '#004ba0',

    },
  },
});

export const ConvertFile = ({Data}: any) => {
  const classes = useStyles();
   
  const { authAxios } = useFetchContext();
  const { mutateAsync: mutatePostFile, isLoading } = usePostReportTemplateUpload();
  const { data: rows = [], isLoading: loadingRows, error: fetchError ,refetch  } = useReportFileTemplate(Data.id);

  const [fileName, setFileName] = useState<File[]>([]);





  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileUpload = async (item: any) => {
    console.log(item)
    fileInputRef.current?.click()
  };

  const handleFilePicked = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      const file = files[0];
      setFileName([file]);
      const datetime = "";
      const report_id = Data.id;
      const workorder_id = Data.work_order_id;

      try {
        await mutatePostFile({
          authAxios,
          file,
          report_id,
          workorder_id,
          // user_id,
          datetime
        });

        toast.success("File uploaded successfully!");
        refetch();
        
      } catch (error: any) {

        toast.error("Error while uploading the file !", error)

      }
    }
  };

  
  const getDownload = (file: string) => {
    const link = document.createElement('a');
    link.href = file;
    link.setAttribute('download', file);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }


  return (
    <div className={classes.container}>

      <div>
        <input
          type="file"
          accept=".docx"
          ref={fileInputRef}
          style={{ display: 'none' }}
          onChange={handleFilePicked}
        />
        {isLoading ? (
          <LinearProgress />
        ) : (
          <Button
            variant="contained"
            color="primary"
            startIcon={<PublishRoundedIcon />}
            onClick={handleFileUpload}
          >
            Upload File
          </Button>
        )}
        <div style={{ marginBottom: 20, textAlign: 'center' }}>

        </div>

        {/* <div style={{ marginBottom: 20, textAlign: 'center' }}>

          {fileName && (
            <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
              Selected: {fileName[0].name}
            </Typography>
          )}
        </div> */}

        {loadingRows ? (
          <LinearProgress />
        ) : (
          <TableContainer component={Paper} className={classes.table}>
            <Table>
              <TableHead>
                <TableRow className={classes.header}>
                  <TableCell align="center" className={classes.cell}>ID</TableCell>
                  <TableCell align="center" className={classes.cell}>NAME</TableCell>
                  <TableCell align="center" className={classes.cell}>DATE</TableCell>
                  <TableCell align="center" className={classes.cell}>USER</TableCell>
                  <TableCell align="center" className={classes.cell}></TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {rows.map((row: any) => (
                  <TableRow key={row.id} className={classes.row}>
                    <TableCell align="center" component="th" scope="row" className={classes.cell}>
                      {row.id}
                    </TableCell>
                    <TableCell align="center" className={classes.cell}>
                      {row.name}
                    </TableCell>
                    <TableCell align="center" className={classes.cell}>
                      {moment(row.datetime).format("DD-MMM-YYYY hh:mm A")}
                    </TableCell>
                    <TableCell align="center" className={classes.cell}>
                      {row.username ? row.username:"N/A"}
                    </TableCell>
                    <TableCell align="center" className={classes.cell}>
                      <IconButton className={classes.iconButton}  onClick={() => getDownload(row.file)}>
                        <FileDownloadIcon  />

                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </div>
    </div>
  );
};